import { render, staticRenderFns } from "./CreateSuppliersPage.vue?vue&type=template&id=1261dbb0&"
import script from "./CreateSuppliersPage.vue?vue&type=script&lang=js&"
export * from "./CreateSuppliersPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports